import axios, { AxiosResponse } from "axios";
axios.defaults.headers.post["Content-Type"] = "application/json; charset=utf-8";

export const instance = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    headers: {
        "Content-Type": "application/json; charset=utf-8",
    },
});

instance.interceptors.request.use(
    async (config) => {
        // Thêm Authorization token nếu có
        const token = sessionStorage.getItem("auth_token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        // Thêm PWC headers
        // const pwcApiKey = sessionStorage.getItem("pwc-api-key") || '9829fb5e3510950a06e0f35886564921';
        // const pwcSecretKey = sessionStorage.getItem("pwc-secret-key") || '032557a2e9ccb866958f49b02cdac9211158115017d050029f3759f284d26563';
        // const pwcSignature = sessionStorage.getItem("pwc-signature") || 'c10ecd858d319218d51cb9cc41ab0fbd0ec40a396927bb75344fe83a0010e723';
        // const pwcTimestamp = sessionStorage.getItem("pwc-timestamp") || '121231231231';
        
        // if (pwcApiKey) {
        //     config.headers["pwc-api-key"] = pwcApiKey;
        // }
        // if (pwcSecretKey) {
        //     config.headers["pwc-secret-key"] = pwcSecretKey;
        // }
        // if (pwcSignature) {
        //     config.headers["pwc-signature"] = pwcSignature;
        // }
        // if (pwcTimestamp) {
        //     config.headers["pwc-timestamp"] = pwcTimestamp;
        // }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


instance.interceptors.response.use(
    (response: AxiosResponse) => {
        return response;
    },
    function (error) {
        if (error.response) {
            return Promise.reject({
                status: error.response.status,
                message: error.response.data.message,
            });
        } else if (error.request) {
            return Promise.reject(error.request);
        } else {
            return Promise.reject(error);
        }
    }
);
